<template>
  <div class="container mt-5">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Paziente {{
            this.$route.path.split("/")[2] }}
        </li>
      </ol>
    </nav>
    <div class="col">
      <h1>Paziente {{ this.$route.path.split("/")[2] }}</h1>
    </div>

    <div v-if="error['motion']" class="error">{{ error }}</div>

    <div v-else>
      <h3 class="h3">Attività</h3>
      <div v-if="motionData.length > 0">
        <button @click="downloadCSV('motion')" class="btn btn-primary">
          <i class="bi bi-file-earmark-arrow-down-fill"></i> Download CSV
        </button>

        <DataTable class="table table-hover table-striped" v-if="motionData" :options="this.options">

          <thead>
          <tr>
            <th v-for="(key, index) in motion_keys" :key="index">
              {{ key }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, rowIndex) in motionData" :key="rowIndex">
            <td v-for="(key, colIndex) in motion_keys" :key="colIndex">
              <template v-if="Array.isArray(item[key])">
                <div v-for="(element, index) in item[key]" :key="index">
                  <template v-if="element.includes('Classe complessiva:')">
                    <b><i>{{ element }}</i></b>
                  </template>
                  <template v-else>
                    {{ element }}
                  </template>
                </div>
              </template>
              <template v-else>
                {{ item[key] }}
              </template>
            </td>
          </tr>
          </tbody>
        </DataTable>
      </div>
      <div v-else>
        <div v-if="loading_states['motion']" id="loading">
          <div id="loading-text">
            Caricamento...
          </div>
          <div class="spinner-border text-dark" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-else>
          Nessun dato motorio presente
        </div>
      </div>
    </div>

    <div v-if="error['steps']" class="error">{{ error }}</div>
    <div v-else>
      <h3 class="h3">Passi</h3>
      <div v-if="steps.length > 0">
        <button @click="downloadCSV('steps')" class="btn btn-primary">
          <i class="bi bi-file-earmark-arrow-down-fill"></i> Download CSV
        </button>
        <DataTable class="table table-hover table-striped" v-if="steps" :options="this.options">
          <thead>
          <tr>
            <th v-for="(key, index) in steps_keys" :key="index">
              {{ key }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, rowIndex) in steps" :key="rowIndex">
            <td v-for="(key, colIndex) in steps_keys" :key="colIndex">
              {{ item[key] }}
            </td>
          </tr>
          </tbody>
        </DataTable>
      </div>

      <div v-else>
        <div v-if="loading_states['steps']" id="loading">
          <div id="loading-text">
            Caricamento...
          </div>
          <div class="spinner-border text-dark" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-else>
          Nessun dato sul numero di passi trovato
        </div>

      </div>

      <div id="map">

      </div>

    </div>
  </div>

</template>

<script>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import 'datatables.net-responsive';
import 'datatables.net-select';

DataTable.use(DataTablesCore);


import {useHead} from "@vueuse/head";

export default {
  setup() {
    useHead({
      title: 'VISAD Dashboard - Dettagli paziente'
    });
  },
  components: {DataTable},
  data() {
    return {
      motionData: [],
      steps: [],
      loading_states: {
        motion: false,
        steps: false
      },
      error: {
        motion: false,
        steps: false
      },
      ticket_id_motion: null,
      intervalId: null,
      markup_data: [],
      motion_keys: ["Data", "Ora", "Attività", "Latitudine", "Longitudine", "Classe di qualità", "Indice di qualità", "Nome stazione", "Calorie app", "Calorie server"],
      steps_keys: ["Data", "Ora", "Num. passi"],
      options: {
        responsive: true,
        select: true,
        order: [[0, 'asc'], [1, 'asc']]
      },

    };
  },
  async mounted() {
    await this.fetchMotionData();
    await this.fetchStepsData();
    // this.generateMap();

  },
  methods: {
    async fetchMotionData() {
      this.loading_states['motion'] = true;
      this.error['motion'] = null;
      try {
        const response = await fetch(`/api/read${this.$route.path}/motion`);
        if (!response.ok) {
          throw new Error('Errore nella richiesta');
        }
        const data = await response.json();
        this.ticket_id_motion = data.ticket_id;
        this.startPolling(); // Start polling immediately
      } catch (error) {
        this.error['motion'] = error.message;
      }
    },
    // 2. Start polling for task 1 (using ticket ID)
    startPolling() {
      const poll = async () => {
        try {
          const response = await fetch(`/api/read/poll/${this.ticket_id_motion}`); // Endpoint for task status
          const data = await response.json();

          if (response.ok) {
            const status = data.status;
            console.log(status);
            if (status === 'completed') {
              this.motionData = data.result_data; // Store result for task 1
              this.loading_states['motion'] = false;
              this.stopPolling(); // Stop polling once task 1 is done
            } else if (status === 'failed') {
              this.loading_states['motion'] = false;
              this.stopPolling(); // Stop polling if task 1 failed
            }
          } else {
            this.loading_states['motion'] = false;
            throw new Error('Failed to fetch task status');
          }
        } catch (err) {
          this.loading_states['motion'] = false;
          this.error = err.message;
          this.stopPolling(); // Stop polling on error
        }
      };

      // Poll every 5 seconds (5000 ms)
      this.intervalId = setInterval(poll, 10000);
    },

    // 3. Stop polling for task 1
    stopPolling() {
      if (this.intervalId) {
        clearInterval(this.intervalId); // Clear the interval for task 1
        this.intervalId = null;
      }
      this.loading = false; // Stop loading spinner
    },
    async fetchStepsData() {
      this.loading_states['steps'] = true;
      this.error['steps'] = null;
      try {
        const response = await fetch(`/api/read${this.$route.path}/steps`);
        if (!response.ok) {
          throw new Error('Errore nella richiesta');
        }
        const data = await response.json();
        if (data.steps_data.length > 0) {
          this.steps = data.steps_data;
        }
        // await this.getAirData(motionData);
      } catch (error) {
        this.error['steps'] = error.message;
      } finally {
        this.loading_states['steps'] = false;
      }
    },
    convertToCSV(type) {
      let header;
      let rows;
      if (type === "motion") {
        header = this.motion_keys;
        rows = this.motionData.map(row =>
          header.map(fieldName => JSON.stringify(row[fieldName], null, 0)).join(';')
        );
      } else if (type === "steps") {
        header = this.steps_keys;
        rows = this.steps.map(row =>
          header.map(fieldName => JSON.stringify(row[fieldName], null, 0)).join(';')
        );
      }
      return [header.join(';'), ...rows].join('\n');
    },
    downloadCSV(type) {
      const csv = this.convertToCSV(type);
      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', type + '_' + this.$route.path.split("/")[2] + '.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  beforeUnmount() {
    // Clean up polling interval if the component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}


</script>

<style>
#map {
  height: 80vh;
}

.leaflet-control-container .leaflet-routing-container-hide {
  display: none;
}

#loading {
  display: flex;
  flex-direction: column; /* Align items vertically */
  justify-content: center; /* Center vertically */
  align-items: center; /* Center horizontally */
  height: 100vh; /* Take full viewport height */
}

#loading-text {
  font-size: 2em; /* Make the text larger */
  margin-bottom: 1rem; /* Add some space between text and spinner */
}

</style>